import React, { useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router';

import Box from '@amzn/meridian/box';
import BreadCrumbs from 'src/components/shared/breadcrumbs/breadcrumbs';

import './siteManagement.scss';
import { findCurrentTabToHighlight, isPathValid } from './tabAndPathUtils';

import TabGroup from './tabGroup/tabGroup';
import EmailDistros from './updateEmailDistributions/emailDistros';
import UpdateShifts from './updateShifts/updateShifts';
import UpdateSiteCapacity from './updateSiteCapacity/updateSiteCapacity';
import SiteWebHooks from './updateWebHooks/siteWebhooks';

const SiteManagement = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [currentTab, setCurrentTab] = useState('update-site-capacity');

  useEffect(() => {
    if (!isPathValid(pathname)) {
      navigate(`/siteManagement/${currentTab}`);
    } else {
      setCurrentTab(findCurrentTabToHighlight(pathname));
    }
  }, [pathname]);

  const onTabChange = (tabVal: string) => {
    navigate('/siteManagement/' + tabVal);
  };

  return (
    <div className="site-management">
      <BreadCrumbs
        breadcrumbList={[
          { label: 'Return To Work 2.0', url: '/' },
          { label: 'Site Management', url: '/siteManagement' },
        ]}
      />

      <div className="site-management__tab-group">
        <TabGroup currentTab={currentTab} setCurrentTab={onTabChange} />
      </div>

      <Box spacingInset="200 500 400 500" className="site-management__content">
        {currentTab === 'update-shifts' && <UpdateShifts />}
        {currentTab === 'update-default-emails' && <EmailDistros />}
        {currentTab === 'update-webhooks' && <SiteWebHooks />}
        {currentTab === 'update-site-capacity' && <UpdateSiteCapacity />}
      </Box>
    </div>
  );
};

export default SiteManagement;
